<template>
  <div>
    <zixun v-if="show"></zixun>
    <ConsultDetails v-else></ConsultDetails>
  </div>
</template>
<script>
import zixun from "./zixun.vue"
import ConsultDetails from "./ConsultDetails/index.vue"
export default{
  metaInfo: {
    title: 'Eiiplat环境产业互联网平台平台资讯',
    meta: [
      { name: 'description', content: 'Eiiplat环境产业互联网平台平台资讯，行业最新动态，市场活动，环保行业动态，青岛国真智慧' },
      { name: 'keywords', content: 'Eiiplat环境产业互联网平台平台资讯，行业最新动态，市场活动，环保行业动态，青岛国真智慧' },
    ],
  },
  components:{
    zixun,
    ConsultDetails
  },
  watch:{
    '$route.query.id':function(newVal,oldVal){
      if(newVal){
        this.show=false
      }else{
        this.show=true
      }
    }
  },
  data(){
    return{
     show:true
    }
  },
  mounted(){
    if(this.$route.query.id){
      this.show=false
    }else{
      this.show=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Information.vue